import ResumeDocAnimation from "./loaders/ResumeDocAnimation";

// Full-screen loading state for short waits (page and sign-in loads).
function FullPageLoader({ message = "Loading..." }: { message?: string }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white/90" role="status">
      <div className="text-center">
        <ResumeDocAnimation size="sm" />
        <p className="mt-5 text-base font-medium text-gray-700">{message}</p>
      </div>
    </div>
  );
}
export default FullPageLoader;
